<template>
  <div class="box">
    <!-- <div class="topBG"></div> -->
    <div class="swiperContentSecond">
      <swiper :options="SwiperOption" ref="mySwiperPC" class="swiperContent">
        <!-- 第一张轮播图:-->
      <swiper-slide class="videoItem swiperslide">
          <div class="loadContent">
            <img
              src="../../assets/image/appDownLoad/pc/banner2.png"
              class="videoImg"
            />
             <div class="videobtnT">
              <a href="https://itunes.apple.com/cn/app/imagine-learning/id638464610?mt=8" target="_blank" class="iosLoad" alt="ipad下载地址"></a>
              <a  href="http://www.4006688991.cn/upload/IL180.apk" class="android" alt="android下载地址"></a>
            </div>
             <div class="videobtnB">
              <a  href="http://www.4006688991.cn/upload/IL.msi" target="_blank" class="android"></a>
            </div>
          <div class="erweima"><img src="../../assets/image/appDownLoad/pc/saoma.png"  class="saomaoImg"/></div>
          </div>
       </swiper-slide> 

        <!--第二张轮播图:想象力世界 -->
       <swiper-slide class="videoItem swiperslide">
          <div class="loadContent">
            <img
              src="../../assets/image/appDownLoad/pc/imagineword_banner.jpg"
              class="videoImg"
            />
            <div class="videobtn">
              <a href="https://apps.apple.com/cn/app/id1454087522">
                <div class="iosLoad"></div>
                <div class="qrcode1"></div>
              </a>
              <a href="https://s3.cn-north-1.amazonaws.com.cn/imagine-packages/imagineworld.apk ">
                <div class="android"></div>
                <div class="qrcode2">

                </div>
              </a>
            </div>
          </div>
        </swiper-slide>   

        <!-- 第三张轮播图：欢乐岛 --> 
    <swiper-slide class="videoItem swiperslide">
          <div class="loadContent">
            <img
              src="../../assets/image/appDownLoad/pc/欢乐岛整体背景@2x.png"
              class="videoImg"
            />
            <div class="hldTitle">想象力欢乐岛</div>
            <div class="videobtnH">
              <a href="https://apps.apple.com/cn/app/id1491000896">
                <img src="../../assets/image/appDownLoad/pc/ios_button.png" class="iosLoad">
                
               <div class="iosQr"></div>
                
                
              </a>
              
               <a href="https://imagine-packages.s3.cn-north-1.amazonaws.com.cn/island.apk">
                <img src="../../assets/image/appDownLoad/pc/andriod_button.png" class="android">
                <div class="androidQr"></div>
                <div class="qrTip">建议使用浏览器扫一扫</div>
               
              </a>
           
            </div>
            <div class="appload-more" @click.stop.prevent="learnMore">
              了解更多
              <span>>></span>
            </div>
          </div>
        </swiper-slide>  
        <!-- 第四张轮播图：想象力课堂-->
        <swiper-slide class="videoItem swiperslide">
          <div class="loadContent">
            <img
              src="../../assets/image/appDownLoad/pc/pcSwiper.jpg"
              class="videoImg"
            />
            <a class="videobtnK" href="http://app.4006688991.cn/download/imagineclassroom.exe">
            </a>
          </div>
        </swiper-slide> 
      


            <div class="swiper-button-prev" @click.stop.prevent slot="button-prev"></div>
            <div class="swiper-button-next" @click.stop.prevent slot="button-next"></div>
        <div
          class="swiper-pagination pagination-pc"
          slot="pagination"
        ></div>
      </swiper>
    </div>
    <div class="check-area-pc" ref="checkAreaRef">
      <div 
        v-for="(productName, index) in productIntroNameList" 
        :key="productName" 
        @click="onShowProductIntro(index)"
        :class="[{activeBtn: activeProductIntroIndex === index}, 'btn-product-intro']"
      >{{productName}}</div>
    </div>
    <div class="userPointer"  v-if="activeProductIntroIndex === 0">
      <div class="userTittle-pc">使用指南</div>
      <div class="khdDown-pc">第一步：客户端下载</div>
      <div class="user-fontSize-pc">如上提示，下载“imagine learning”安装包。</div>
      <div class="zysx-pc">客户端下载注意事项： 不同设备、不同的系统版本有些许区别，详情请点击查看<a
          href="http://www.imaginelearning.cn/upload/美国想象力英语_操作指南.pdf"
          target="_blank"
        >下载操作指南。</a></div>
      <div class="khdDown-pc syzh-pc">第二步：注册试用账号</div>
      <div>点击下方文本框填写信息，注册试用账号。</div>
      <div class="phoneNumPwd-pc">手机号码和您填写的密码，即为Imagine Learning的试用账号。</div>
      <div class="regNewZh"><img
          style='width:100%;height:100%;'
          src="../../assets/image/appDownLoad/pc/img_biaodan_pc.png"
          alt=""
        ></div>
      <div class="khdDown-pc">第三步：登录账号</div>
      <div>1、打开“Imagine Learning”客户端，填写<span>4006688991.com”，点击connect进入系统</span></div>
      <div class="zcpLoginJianJu-pc">2、如下图：填写注册时的手机号、密码，点击登录。</div>
      <div class="zcLoginBg-pc"><img
          src="../../assets/image/appDownLoad/pc/img_denglu.png"
          alt=""
        ></div>
      <div>3、进入系统，可以开始学习啦！</div>
      <div class="footLB-pc">
        <div class="LB-pc">
          <span
            class="qhbtn juTopF"
            @click="switchBG('left')"
          ><img
              src="../../assets/image/appDownLoad/pc/forward.png"
              alt=""
            ></span>
          <span class="lbZBg-pc"><img
              :src="LBBGUrl[footLB]"
              alt=""
              class="zbg-img"
            >
            <span class="lbNumBtn-pc">
              <img
                :src="LBbtnNumUrl[footLB]"
                alt=""
              >
            </span>
          </span>
          <span
            class="qhbtn juTopL"
            @click="switchBG()"
          ><img
              src="../../assets/image/appDownLoad/pc/back.png"
              alt=""
            ></span>
        </div>
        <div class="cjProbom-pc">
          <div class="cjProTittle-pc"> 注：操作常见问题</div>
          <div>1、 APP Store如何寻找Imagine Learning学习软件？</div>
          <div class="FmarPro-pc">登录appstore，搜索ImagineLearning（注意：需要IOS6以上版本）</div>
          <div>2、登录页面，等待过程中一直白屏? </div>
          <div class="SmarPro-pc">刷新一下页面。</div>
          <div>3、家长如何看到用户的学习内容 </div>
          <div class="LmarPro-pc">关注“美国想象力英语”公众号，</div>
          <div>在菜单栏的“用户中心”中选择“学习报告”，绑定账号即可。</div>
        </div>
      </div>
    </div>
    <div class="islandPoint" v-else-if="activeProductIntroIndex === 1"> 
      <div class="allDownload1">
        <img class="fragment" src="../../assets/image/appDownLoad/pc/矩形top.png" alt="">
        <img class="fragment" src="../../assets/image/appDownLoad/pc/分组100.png" alt="">
        <img class="fragment" src="../../assets/image/appDownLoad/pc/分组101.png" alt="">
      </div>
    </div>
    <div class="joyjoyPoint"> 
      <div class="allDownload1">
        <img class="fragment" src="../../assets/image/appDownLoad/pc/pic_joyjoy1.jpg" alt="">
        <img class="fragment" src="../../assets/image/appDownLoad/pc/pic_joyjoy2.jpg" alt="">
        <img class="fragment" src="../../assets/image/appDownLoad/pc/pic_joyjoy3.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      footLB: 0,
      intro:"imagine-english",
      engCheck:false,
      islandCheck:false,
      productIntroNameList: ['想象力英语'],
      // , '欢乐岛', 'JoyJoy快乐玩'
      LBbtnNumUrl: [
        require("../../assets/image/appDownLoad/pc/number_1.png"),
        require("../../assets/image/appDownLoad/pc/number_2.png"),
        require("../../assets/image/appDownLoad/pc/number_3.png"),
        require("../../assets/image/appDownLoad/pc/number_4.png"),
        require("../../assets/image/appDownLoad/pc/number_5.png")
      ],
      LBBGUrl: [
        require("../../assets/image/appDownLoad/pc/LBBG1.png"),
        require("../../assets/image/appDownLoad/pc/LBBG2.png"),
        require("../../assets/image/appDownLoad/pc/LBBG3.png"),
        require("../../assets/image/appDownLoad/pc/LBBG4.png"),
        require("../../assets/image/appDownLoad/pc/LBBG5.png")
      ],
      SwiperOption: {
        slidesPerView: 1,
        initialSlide: 0,
        centeredSlides: true,
        loop:true,
        autoplay:{
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
         navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "my-button-disabled"
        },
      },
      activeProductIntroIndex: 0
    };
  },
  created() {},
  methods: {
    switchBG(biaoshi) {
      if (biaoshi === "left") {
        if (this.footLB === 0) {
          this.footLB = 4;
        } else {
          this.footLB--;
        }
      } else {
        if (this.footLB === 4) {
          this.footLB = 0;
        } else {
          this.footLB++;
        }
      }
    },
    checkEng(){
       this.intro='imagine-english',
       this.engCheck=true
       this.islandCheck=false
    },
    checkIsland(){
      this.intro='imagine-island'
      this.engCheck=false
      this.islandCheck=true
    },
    onShowProductIntro(productIntroIndex) {
      this.activeProductIntroIndex = productIntroIndex;
    },
    learnMore(){
      this.checkIsland()
      console.log("hahhah",this.$refs.checkAreaRef);
      this.$refs.checkAreaRef.scrollIntoView({ behavior: "smooth",block:"start"}) 
    }

  }
};
</script>
<style scoped lang="scss">
// @import '~style/mixin.scss';
.swiperContentSecond {
    width: 100%;
  height: vp(704);
  .swiper-container {
    height: vp(704);
    width: 100%;
    .loadContent{
      .videoImg{
        width: 100%;
      }
    }
  }
  .swiper-button-next {
  width: vp(70);
  height: vp(70);
  background-image: url("../../assets/image/appDownLoad/pc/arrow_normal_right.png");
  opacity: 0;
  transition: all 1s;
}
  .swiper-button-prev {
  width: vp(70);
  height: vp(70);
  background-image: url("../../assets/image/appDownLoad/pc/arrow_nomal_left.png");
  opacity: 0;
  transition: all 1s;
}
.swiperContent:hover .swiper-button-prev {
  opacity: 1;
}
.swiperContent:hover .swiper-button-next {
  opacity: 1;
}
.swiper-button-prev:hover {
  background-image: url("../../assets/image/appDownLoad/pc/arrow_hower_left.png");
}
.swiper-button-next:hover {
  background-image: url("../../assets/image/appDownLoad/pc/arrow_hower_right.png");
}
  .videobtnK{
     position: absolute;
      top: vm(120);
      left: vm(446);
      width: vm(164);
      height: vm(50);
      background-color: red;
      opacity: 0;
    

  }
 
  .videobtn {
    position: absolute;
    top: vp(386);
    left: vp(996);
    display: flex;
    width: vp(807);
    justify-content: space-around;
    .iosLoad {
      height: vp(67);
      width: vp(278);
      background: url(../../assets/image/appDownLoad/pc/ios_button.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
     
    }
     .android {
      height: vp(67);
      width: vp(279);
      margin-left: vp(35);
      background: url(../../assets/image/appDownLoad/pc/andriod_button.png);
      background-size: 100% 100%;
    }
    .qrcode1{
      position: absolute;
      width: vp(144);
      height: vp(144);
      left: vp(127);
      top: vp(90);
      background: url(../../assets/image/appDownLoad/pc/ioscode@2x.png);
      background-size: cover
    }
   
    .qrcode2{
      position: absolute;
      width:vp(144) ;
      height: vp(144);
      left: vp(541);
      top: vp(90);
      background: url(../../assets/image/appDownLoad/pc/安code@2x.png);
      background-size: cover
    }
    .iPad{
     
      height: vp(67);
      width: vp(279);
      margin-left: vp(31);
      // background: url(../../assets/image/appDownLoad/pc/ipadcopy@2x.png) 50%;
      background-size: cover;
      margin-bottom: vp(30);
      opacity: 0.5;
      img {
        width: 100%;
        height: 100%;
       
      }
    }
    .ipadtext{
      width:vp(217);
      height:vp(37);
      font-size:vp(26);
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(169,218,253,1);
      line-height:vp(37);
      text-indent: 4em;

    

    }
    .tips{
      color:#CAFA4C;
      text-align: center;
    }
   
  }
   .appload-more{
     position: absolute;
     width:vp(196);
     height:vp(48);
     font-size:vp(34);
     font-family:PingFangSC-Medium,PingFang SC;
     font-weight:500;
     color:rgba(255,255,255,1);
     line-height:vp(48);
     top:vp(583);
     left:vp(958);
   }
   .appload-more:hover{
     background-color: #A3DC0E;
     cursor: pointer;
     border: 2px solid #fff;
     border-radius:vp(10);
     
   }
   .hldTitle{
      top: vp(103);
      right: vp(118);
      position: absolute;
     
font-size:vp(82);
font-family:PingFangSC-Semibold,PingFang SC;
font-weight:600;
color:rgba(255,255,255,1);
line-height:115px;

    }
   .videobtnH {
    position: absolute;
    top: vp(285);
    left: vp(1058);
    display: flex;
    width: vp(700);
    justify-content: space-around;
    .qrTip{
      transform: translateX(vp(15));
      color:#fff;
    }
    

    .iosLoad {
      height: vp(67);
      width: vp(279);
      background: url(../../assets/image/appDownLoad/pc/ios_button.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
     
    }
    .iosQr{
      position: absolute;
      // left: 50%;
      // transform: translateX(-50%);
      margin-top:vp(20) ;
      
     margin-left: vp(50);
      width: vp(180);
      height: vp(180);
      background: url(../../assets/image/appDownLoad/pc/欢乐岛ios@2x.png);
      background-size: 100% 100%;
      

    }
    .androidQr{
      margin-top:vp(20) ;
     margin-left: vp(80);
      
       width: vp(180);
       height: vp(180);
      background: url(../../assets/image/appDownLoad/pc/欢乐岛andriod@2x.png);
      background-size: 100% 100%;
      
       

    }
    .android {
      height: vp(67);
      width: vp(279);
      margin-left: vp(31);
      background: url(../../assets/image/appDownLoad/pc/andriod_button.png);
      background-size: 100% 100%;
    }
     
    .tips{
      font-size: vp(26);
      color:#CAFA4D;
      line-height: vp(37);
      margin-top: vp(16);
    }
     .tip2{
      font-size: vp(26);
      color:#CAFA4D;
      line-height: vp(37);
      text-align: center;
      padding-left: vp(31);
      margin-top: vp(16);
      
    }
  }
  .videobtnT {
    position: absolute;
    top: vp(389);
    left: vp(1220);
    display: flex;
    width: vp(587);
    .iosLoad {
      height: vp(67);
      width: vp(278);
      background: url(../../assets/image/appDownLoad/pc/ipad_button.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      
    }
    .android {
      height: vp(67);
      width: vp(279);
      margin-left: vp(35);
      background: url(../../assets/image/appDownLoad/pc/androd_button.png);
      background-size: 100% 100%;
    }
  }
  .videobtnB {
    position: absolute;
    top: vp(515);
    left: vp(1220);
    display: flex;
    width: vp(587);
    .iosLoad {
      height: vp(67);
      width: vp(278);
      background: url(../../assets/image/appDownLoad/pc/macPc.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      
    }
    .android {
      height: vp(67);
      width: vp(279);
      // margin-left: vp(35);
      background: url(../../assets/image/appDownLoad/pc/windows_button.png);
      background-size: 100% 100%;
    }
  }
}
.erweima{
  position: absolute;
  top: vp(375);
  left: vp(1019);
  .saomaoImg{
     width: vp(160);
  height: vp(206);
  }
}
.topBG {
  width: 100vw;
  height: vp(497);
  // height: 26vw;

  background: url(../../assets/image/appDownLoad/pc/banner3.png);
}
.khdDownLoad {
  font-family: SHS-B;
  color: #e2211c;
  text-align: center;
  margin-top: vp(102);
  margin-bottom: vp(47);
  font-size: 3.125vw;
}
.padDownLoad-pc {
  height: vp(249);
  margin-left: vp(534);
  margin-right: vp(108);
}
.padDownLoad-pc,
.android-pc,
.imacDownLoad-pc,
.windowsDownLoad-pc {
  display: inline-block;
  height: vp(249);
  width: vp(228);
}
.padDownLoad-pc > img,
.android-pc > img,
.imacDownLoad-pc > img,
.windowsDownLoad-pc > img {
  width: 100%;
  height: 100%;
}
.android-pc {
  margin-right: vp(86);
}
.pbAndCode {
  display: inline-block;
  font-size: vp(16);
  color: #333333;
  font-family: SHS-R;
  margin-top: vp(218);
}
.downLoadBox-F {
  // background: red;
  margin-bottom: 1px;
}
.imacDownLoad-pc {
  margin-left: vp(332);
  margin-right: vp(113);
}
.windowsDownLoad-pc {
  margin-right: vp(286);
}
.installCode-phone {
  text-align: right;
  font-size: vp(16);
  font-family: SHS-R;
  font-weight: normal;
  font-stretch: normal;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  width: vp(320);
  height: vp(249);
  // background: red;
}
.img_saoma-pc {
  margin-top: vp(28);
  display: inline-block;
  // width: vp(160);
  // height: vp(156);

  margin-bottom: vp(4);
  vertical-align: top;
}
.img_saoma-pc > img {
  width: vp(160);
  height: vp(156);
  // background: 100% 100%;
}
.userPointer {
  text-align: center;
  font-size: vp(16);
  font-family: SHS-R;
  color: #333333;
}
.userTittle-pc {
  margin-top: vp(66);
  font-family: SHS-B;
  font-size: vp(60);
  color: #e1251b;
  margin-bottom: vp(48);
}
.khdDown-pc {
  font-size: vp(36);
  margin-bottom: vp(26);
}
.user-fontSize-pc {
  // font-size: vp(16);
  // font-family: SHS-R;
  // color: #333333;
}
.zysx-pc {
  margin-top: vp(12);
  margin-bottom: vp(44);
}
.syzh-pc {
  margin-bottom: vp(29);
}
.phoneNumPwd-pc {
  margin-top: vp(15);
  margin-bottom: vp(44);
}
.regNewZh {
  margin: 0 auto;
  // text-align: center;
  width: vp(607);
  height: vp(653);
  margin-bottom: vp(17);
}
.regNewZh > img {
  width: 100%;
  height: 100%;
}
.zcpLoginJianJu-pc {
  margin-top: vp(9);
  margin-bottom: vp(31);
}
.zcLoginBg-pc {
  margin: 0 auto;
  width: vp(576);
  height: vp(431);
  margin-bottom: vp(29);
}
.zcLoginBg-pc > img {
  width: 100%;
  height: 100%;
}
.footLB-pc > img {
  width: 100%;
  height: 100%;
}
.footLB-pc {
  height: vp(608);
  display: flex;
  margin-bottom: vp(143);
  margin-top: vp(48);
}
.LB-pc {
  display: flex;
  height: 100%;
  width: vp(485);

  // vertical-align: top;
}
.LB-pc > span {
  display: inline-block;
  vertical-align: top;
}
.qhbtn {
  width: vp(49);
  height: vp(49);
}
.LB-pc > img {
  width: vp(49);
  height: vp(49);
}
.cjProbom-pc {
  margin-left: vp(71);
  flex: 1;
  text-align: left;
}
.lbZBg-pc {
  height: 100%;
  width: vp(287);
}
.zbg-img {
  width: 100%;
  height: vp(513);
}
.LB-pc {
  margin-left: vp(422);
}
.juTopF {
  margin-top: vp(223);
  margin-right: vp(48);
}
.juTopL {
  margin-top: vp(223);
  margin-left: vp(48);
}
.cjProTittle-pc {
  color: #e1251b;
  font-family: SHS-B;
  font-size: vp(36);
  margin-bottom: vp(26);
}
.FmarPro-pc {
  margin-top: vp(13);
  margin-bottom: vp(43);
}
.SmarPro-pc {
  margin-top: vp(17);
  margin-bottom: vp(48);
}
.LmarPro-pc {
  margin-top: vp(17);
  margin-bottom: vp(17);
}
.lbNumBtn-pc {
  padding-top: vp(39);
  display: blcok;
  width: vp(43);
  height: vp(43);
  line-height: vp(43);
  text-align: center;
}
.lbNumBtn-pc > img {
  width: vp(43);
  height: vp(43);
}
.qhbtn:hover {
  cursor: pointer;
}
a:link,
a:visited {
  text-decoration: none;
  color: #e1251b;
}
// 选择按钮显示内容区域
.check-area-pc{
  width: 100%;
  height: vp(110);
  background-color: fff;
  display: flex;
  justify-content: center;
  .btn-product-intro {
    font-size:vp(34);
    text-align: center;
    line-height: vp(82);
    width:vp(244);
    height:vp(82);
    border-radius:vp(61);
    border:2px solid rgba(51,51,51,1);
    margin-top: vp(14);
    margin-right: vp(93);
    user-select: none;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
  }
}
.activeBtn{
  background-color: red;
   color:#fff;
   border: 2px solid red !important;
}
.islandPoint{
  .cate9{
    position: relative;
    width: vp(1920);
    height: vp(689);
    // background:url("../../assets/image/appDownLoad/pc/分组9.png") no-repeat center;
  //   transform: scale(0.5);
  //   transform-origin: left top;
   .cate9text{
   font-size: 34px;
   text-align: center;
     position: absolute;
     top: 406px;
   }
    
  }
  .cate9copy{
    width:1353px;
    height:836px;
    margin:68px auto;
    // background:url("../../assets/image/appDownLoad/pc/分组9copy.png") no-repeat center;;
    box-shadow:0px 0px 24px 15px rgba(0,0,0,0.08);
    border-radius:6px;
  }
  .cate21{
    position: relative;
    width:1920px;
    height: 978px;
    margin: 0 auto;
    // background:url("../../assets/image/appDownLoad/pc/分组21.png") no-repeat center;;
    .learn{
      position: absolute;
      top:-20px;
      width: 380px;
      height: 137px;
      margin: 0 auto;
      left:770px;
      // background:url("../../assets/image/appDownLoad/pc/分组23.png") no-repeat center center;;
      p.one{
       font-size: 64px;
       text-align: center;
       line-height: 137px;
       color: #fff;
      }
      
    }


  
  .cate10{
    position: relative;    
    width: 1922px;
    height: 1286px;
    margin: 0 auto;
    // background:url("../../assets/image/appDownLoad/pc/分组10.png") no-repeat center;;
    .exercise{
      position: absolute;
      top:-20px;
      width: 380px;
      height: 137px;
      margin: 0 auto;
      left:770px;
      // background:url("../../assets/image/appDownLoad/pc/分组24.png") no-repeat center center;;
      p.one{
       font-size: 64px;
       text-align: center;
       line-height: 137px;
       color: #fff;
      }
    }
  }
  .cate20{
    position: relative;    
    width: 1922px;
    height: 978px;
    margin: 0 auto;
    // background:url("../../assets/image/appDownLoad/pc/分组20.png") no-repeat center;;
     .test{
      position: absolute;
      top:-20px;
      width: 380px;
      height: 137px;
      margin: 0 auto;
      left:770px;
      // background:url("../../assets/image/appDownLoad/pc/分组25.png") no-repeat center center;;
      p.one{
       font-size: 64px;
       text-align: center;
       line-height: 137px;
       color: #fff;
      }
    }

  }
  .cate33{
    position: relative;    
    width: 1922px;
    height: 1219px;
    margin: 0 auto;
    // background:url("../../assets/image/appDownLoad/pc/分组33.png") no-repeat center;;
     .play{
      position: absolute;
      top:-20px;
      width: 380px;
      height: 137px;
      margin: 0 auto;
      left:770px;
      // background:url("../../assets/image/appDownLoad/pc/分组26.png") no-repeat center center;;
      p.one{
       font-size: 64px;
       text-align: center;
       line-height: 137px;
       color: #fff;
      }
    }
  }

  .allDownload1{
    width: vp(1920);
  }
  }


.fragment{
      width: vp(1920)
    }

}

.joyjoyPoint {
  .fragment{
    width: 50%;
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/appDownLoad/pcAppDownLoad.vue